exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-popup-dialog {\n  z-index: 5001 !important;\n}\n", ""]);

// exports
